{
    "v": "5.7.4",
    "fr": 24,
    "ip": 0,
    "op": 48,
    "w": 500,
    "h": 500,
    "nm": "47-Verified",
    "ddd": 0,
    "assets": [],
    "layers": [
        {
            "ddd": 0,
            "ind": 1,
            "ty": 3,
            "nm": "Main Stroke width - Color Ctrl",
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [250, 250, 0], "ix": 2, "l": 2 },
                "a": { "a": 0, "k": [250, 250, 0], "ix": 1, "l": 2 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
            },
            "ao": 0,
            "ef": [
                {
                    "ty": 5,
                    "nm": "Stroke width",
                    "np": 3,
                    "mn": "ADBE Slider Control",
                    "ix": 1,
                    "en": 1,
                    "ef": [
                        {
                            "ty": 0,
                            "nm": "Slider",
                            "mn": "ADBE Slider Control-0001",
                            "ix": 1,
                            "v": { "a": 0, "k": 24, "ix": 1 }
                        }
                    ]
                },
                {
                    "ty": 5,
                    "nm": "Base Color",
                    "np": 3,
                    "mn": "ADBE Color Control",
                    "ix": 2,
                    "en": 1,
                    "ef": [
                        {
                            "ty": 2,
                            "nm": "Color",
                            "mn": "ADBE Color Control-0001",
                            "ix": 1,
                            "v": {
                                "a": 0,
                                "k": [0.047, 0.047, 0.047, 1],
                                "ix": 1,
                                "x": "var $bm_rt;\n$bm_rt = effect('Base Color')('Color');"
                            }
                        }
                    ]
                },
                {
                    "ty": 5,
                    "nm": "Highlight",
                    "np": 3,
                    "mn": "ADBE Color Control",
                    "ix": 3,
                    "en": 1,
                    "ef": [
                        {
                            "ty": 2,
                            "nm": "Color",
                            "mn": "ADBE Color Control-0001",
                            "ix": 1,
                            "v": {
                                "a": 0,
                                "k": [0.2, 0.2549, 0.3333, 1],
                                "ix": 1,
                                "x": "var $bm_rt;\n$bm_rt = effect('Highlight')('Color');"
                            }
                        }
                    ]
                }
            ],
            "ip": 0,
            "op": 48,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 2,
            "ty": 4,
            "nm": "47-Verified",
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [250, 250, 0], "ix": 2, "l": 2 },
                "a": { "a": 0, "k": [250, 250, 0], "ix": 1, "l": 2 },
                "s": {
                    "a": 1,
                    "k": [
                        {
                            "i": { "x": [0.25, 0.25, 0.25], "y": [1, 1, 1] },
                            "o": { "x": [0.167, 0.167, 0.167], "y": [0.167, 0.167, 0] },
                            "t": 0,
                            "s": [100, 100, 100]
                        },
                        {
                            "i": { "x": [0.25, 0.25, 0.25], "y": [1, 1, 1] },
                            "o": { "x": [0.75, 0.75, 0.75], "y": [0, 0, 0] },
                            "t": 5,
                            "s": [88, 88, 100]
                        },
                        {
                            "i": { "x": [0.833, 0.833, 0.833], "y": [0.833, 0.833, 1] },
                            "o": { "x": [0.75, 0.75, 0.75], "y": [0, 0, 0] },
                            "t": 11,
                            "s": [88, 88, 100]
                        },
                        {
                            "i": { "x": [0.833, 0.833, 0.833], "y": [0.833, 0.833, 0.833] },
                            "o": { "x": [0.167, 0.167, 0.167], "y": [0.167, 0.167, 0.167] },
                            "t": 18,
                            "s": [100, 100, 100]
                        },
                        {
                            "i": { "x": [0.833, 0.833, 0.833], "y": [0.833, 0.833, 0.833] },
                            "o": { "x": [0.167, 0.167, 0.167], "y": [0.167, 0.167, 0.167] },
                            "t": 20,
                            "s": [95, 95, 100]
                        },
                        { "t": 22, "s": [100, 100, 100] }
                    ],
                    "ix": 6,
                    "l": 2
                }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": { "x": 0.833, "y": 0.833 },
                                        "o": { "x": 0.167, "y": 0.167 },
                                        "t": 0,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [-83.095, -5.315],
                                                    [-23.861, 53.478],
                                                    [83.095, -53.478]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.833, "y": 0.833 },
                                        "o": { "x": 0.167, "y": 0.167 },
                                        "t": 2,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [-83.095, -5.315],
                                                    [-23.861, 53.478],
                                                    [-23.791, 53.764]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.833, "y": 0.833 },
                                        "o": { "x": 0.167, "y": 0.167 },
                                        "t": 4,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [-83.095, -5.315],
                                                    [-83.314, -6.028],
                                                    [-83.244, -5.742]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.833, "y": 0.833 },
                                        "o": { "x": 0.167, "y": 0.167 },
                                        "t": 12,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [-83.095, -5.315],
                                                    [-83.314, -6.028],
                                                    [-83.244, -5.742]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.5, "y": 1 },
                                        "o": { "x": 0.167, "y": 0.167 },
                                        "t": 17,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [-83.095, -5.315],
                                                    [-23.861, 53.478],
                                                    [-23.791, 53.764]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "t": 44,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [-83.095, -5.315],
                                                    [-23.861, 53.478],
                                                    [83.095, -53.478]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    }
                                ],
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [0.2, 0.2549, 0.3333, 1],
                                "ix": 3,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Highlight')('Color');"
                            },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 24,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Slider');"
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [246.47, 244.372], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": {
                                "a": 1,
                                "k": [
                                    { "t": 4, "s": [100], "h": 1 },
                                    { "t": 5, "s": [0], "h": 1 },
                                    { "t": 11, "s": [0], "h": 1 },
                                    { "t": 12, "s": [100], "h": 1 }
                                ],
                                "ix": 7
                            },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 1",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, -100.858],
                                        [100.858, 0],
                                        [0, 100.858],
                                        [-100.858, 0]
                                    ],
                                    "o": [
                                        [0, 100.858],
                                        [-100.858, 0],
                                        [0, -100.858],
                                        [100.858, 0]
                                    ],
                                    "v": [
                                        [182.62, 0],
                                        [0, 182.62],
                                        [-182.62, 0],
                                        [0, -182.62]
                                    ],
                                    "c": true
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [0, 0, 0, 1],
                                "ix": 3,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Base Color')('Color');"
                            },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 24,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Slider');"
                            },
                            "lc": 1,
                            "lj": 1,
                            "ml": 10,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [250, 250], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 2",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 2,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 48,
            "st": 0,
            "bm": 0
        }
    ],
    "markers": []
}
